import axios from "axios";

let ReactAppUrl;
// if (process.env.REACT_APP_ENV === "production") {
  // ReactAppUrl = process.env.REACT_APP_PRODUCTION_API_URL;
// } else {
  ReactAppUrl = "https://apk.jayeek.net/api/admin";
  // ReactAppUrl = "http://localhost:50011/admin";
  
// }

// Create axios instance with the dynamic base URL
const instance = axios.create({
  baseURL: ReactAppUrl,
});

// Set default content type for requests
instance.defaults.headers.common["content-type"] = "multipart/form-data";

// Request interceptor to add authentication tokens and language_id
instance.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem("jayeek_accessToken");
  const refreshToken = localStorage.getItem("refreshToken");
  const languageId = localStorage.getItem("language_id") || "1"; 

  if (accessToken) {
    config.headers["Authorization"] = `Bearer ${accessToken}`;
  }

  if (refreshToken) {
    config.headers["x-refresh-token"] = refreshToken;
  }

  // Exclude language_id for login API
  const isLoginRequest = config.url.includes("/login");

  if (!isLoginRequest) {
  
    if (config.method === "get") {
      config.params = { ...config.params };
    }

    // Add language_id to data for POST requests
    if (config.method === "post") {
      if (config.data instanceof FormData) {
        config.data.append("language_id", languageId);
      } else {
        config.data = { ...config.data, language_id: languageId };
      }
    }
  }

  return config;
});

export default instance;
